import type { SelectHTMLAttributes } from 'react';

export type SelectOption = { value: string; label: string };

export type SelectProps = Omit<SelectHTMLAttributes<HTMLSelectElement>, 'onChange'> & {
  label?: string;
  options: Array<SelectOption | string>;
  placeholder?: string;
  onChange?: (value: string) => void;
};

export function Select({
  label,
  options,
  placeholder,
  onChange,
  className = '',
  id,
  ...rest
}: SelectProps) {
  const selectEl = (
    <div className="select-wrap">
      <select
        id={id}
        className={`input ${className}`}
        onChange={(e) => onChange?.(e.target.value)}
        {...rest}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((o) =>
          typeof o === 'string' ? (
            <option key={o} value={o}>
              {o}
            </option>
          ) : (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ),
        )}
      </select>
    </div>
  );
  if (!label) return selectEl;
  return (
    <div>
      <label className="field-label" htmlFor={id}>
        {label}
      </label>
      {selectEl}
    </div>
  );
}
